import React from 'react';

const digitalClock = ({time}) => <h1>{time}</h1>

export default digitalClock;
